@if (label()) {
  <label
    class="block"
    [for]="componentId"
  >
    {{ label() }}
  </label>
}

<mat-radio-group
  aria-label="Select an option"
  [formControl]="control()"
  [id]="componentId"
>
  @for (option of options(); track option) {
    <mat-radio-button [value]="option.value">
      {{ option.label }}
    </mat-radio-button>
  }
</mat-radio-group>
